"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const safeFallback = "gb";
const getGeoCountry = ip => fetch(`https://geoip-api.skypicker.com/${ip ? `?ip=${ip}` : ""}`).then(res => res.json()).then(data => {
  // "" is returned when IP is invalid
  if (data.isoCountryCode === "") {
    return safeFallback;
  }
  return data.isoCountryCode.toLowerCase();
}).catch(() => safeFallback);
var _default = getGeoCountry;
exports.default = _default;